import common from './common.json'
import showcaseFlex from './schemes/showcase-flex.json'

export default {
  common,
  'showcase-flex': showcaseFlex,
}
